//全局语言变量
export default {
  state: {
    en: 'English',
    zh: '简体中文'
  }
}